import React, { createContext, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance"; // ✅ обов’язково

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [authChecked, setAuthChecked] = useState(false); // ✅ нове
  const navigate = useNavigate();

  // ✅ Перевірка авторизації через cookie (JWT у httpOnly cookie)
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axiosInstance.get("/auth/me");
        if (response.data) {
          setIsLoggedIn(true);
        }
      } catch (error) {
        setIsLoggedIn(false);
        // console.warn(
        //   "🔐 Користувач не авторизований:",
        //   error.response?.data || error.message
        // );
      } finally {
        setAuthChecked(true); // ✅ після спроби
      }
    };

    checkAuth();
  }, []);

  // ✅ Вхід
  const login = () => {
    setIsLoggedIn(true);
    setAuthChecked(true); // ✅ одразу після логіну
    navigate("/");
  };

  // 🚪 Вихід
  const logout = async () => {
    try {
      await axiosInstance.post("/auth/logout");
      setIsLoggedIn(false);
      setAuthChecked(true); // ✅ після виходу
      navigate("/");
    } catch (error) {
      console.error("❌ Помилка при виході:", error);
    }
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, authChecked, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
